export default __webpack_public_path__ + "static/media/andyClick.32a52b45.png";